export default __webpack_public_path__ + "static/media/co2-globe.d7bae676.png";